const STYLES: Record<string, string> = {
  CRITICAL: 'bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-300',
  HIGH: 'bg-orange-100 text-orange-800 dark:bg-orange-950 dark:text-orange-300',
  MEDIUM: 'bg-amber-100 text-amber-900 dark:bg-amber-950 dark:text-amber-200',
  LOW: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
  INFO: 'bg-blue-50 text-blue-800 dark:bg-blue-950 dark:text-blue-300',
};

export function WorkQueuePriorityBadge({ priority }: { priority: string }) {
  const key = (priority ?? 'MEDIUM').toUpperCase();
  return (
    <span
      className={`inline-flex rounded-full px-2 py-0.5 text-xs font-semibold ${STYLES[key] ?? STYLES.MEDIUM}`}
    >
      {key}
    </span>
  );
}
